import i18n from '@/i18n';
import loadable from '@loadable/component';

export default () => [
  {
    needLogin: false,
    resourceName: i18n.t('login-index-1992f2b803785e7de-1'),
    routerUrl: '/login',
    type: '2',
    resourceIcon: '',
    buttons: [],
    component: loadable(() => import('./Login')),
  },
];
